import './style.css'
import { createRoot } from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Leva } from 'leva'
import Geos from '../Geos'
import * as THREE from 'three'

const root = createRoot(document.querySelector('#root'))

root.render(
    <>
        <Leva titleBar={{ title: 'Model Settings' }} />
        <Canvas camera={{
          fov:75,
          near:0.5,
          far:9,
          position:[0,2,7]
        }}
        dpr={[1,2]}
        gl={{
          antialias:true,
          toneMapping: THREE.ACESFilmicToneMapping,
          outputColorSpace:THREE.SRGBColorSpace
        }}>
          <Geos/>
        </Canvas>
        <div className="contact-panel">
          <span className="contact-title">Amir Fallahi</span>
          <a href="https://www.linkedin.com/in/devamir/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="tel:09205007494">09205007494</a>
          <a href="mailto:devamir99@gmail.com">devamir99@gmail.com</a>
        </div>
    </>
)